/** @format */

import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as StarFilled } from "../../assets/icons/star-fill.svg";
import FeatureFlag from "../featureFlag/FeatureFlag";
type Props = {
  isStarred?: boolean | undefined;
  onClick: () => void;
};
const StarResource: FC<Props> = ({ onClick, isStarred }) => {
  const { t: _ } = useTranslation();
  return (
    <FeatureFlag flag={["starResource"]}>
      <div className="star-container">
        <StarFilled
          title={isStarred ? _("Un-star?") : _("Star?")}
          className={isStarred ? "star filled" : "star"}
          role="button"
          onClick={() => {
            onClick();
          }}
        />
      </div>
    </FeatureFlag>
  );
};

export default StarResource;
